import * as React from "react";

import Trending from "../components/Trending";

import InnerPage from "../components/InnerPage";

export default function AlertsScreen() {
  return (
    <InnerPage title="Trending Units">
      <Trending showDelete={true} direction={"column"} />
    </InnerPage>
  );
}
